module.exports = __webpack_public_path__ + "static/media/descubre.626fc1ff.svg";